<template>
  <div id="container" v-if="fetch_total_ranks">
    <section id="atsuatsu" class="list">
      <div class="wrap">
        <div class="cts_box">
          <h1 class="main_ttl"><span>アツアツ銘柄コンテスト</span></h1>

          <div class="body_tbl">
            <h3 class="min_ttl"><span>全期間ランキングランキング</span></h3>
            <div class="radio">
              <input id="radio-1" type="radio" v-model="total_rank" value="ranks_adv">
              <label for="radio-1">平均</label>
              <input id="radio-2" type="radio" v-model="total_rank" value="ranks_rate">
              <label for="radio-2">最高値</label>
            </div>
          </div>
        </div>

        <div class="box list">

          <div class="scrl_wrap">
            <table class="point_history total-ranks mb40">
              <tbody>
              <tr class="header">
                <th class="rank">順位</th>
                <th class="number">塾生番号</th>
                <th class="entry-count">エントリー回数</th>
                <th class="rate-adv">騰落率</th>
                <th class="rate-max">最高値</th>
                <th class="rate-min">最低値</th>
              </tr>

              <tr v-for="m in fetch_total_ranks[total_rank]" :key="'total-list-' + m.user_number">
                <td class="rank-value">{{ m.rank ? `第${m.rank}位` : '-' }}</td>
                <td class="number-value">
                  <template v-if="m.user_id">
                    <router-link :to="{ name: 'SnsTimeline', params: {user_id: m.user_id}}">
                      {{ Number(m.user_number) }}
                    </router-link>
                  </template>
                  <template v-else>
                    {{ Number(m.user_number) }}
                  </template>
                </td>
                <td>{{ m.entry_count }}</td>
                <td class="rate-adv" v-bind:class="{plus: m.rate_adv >= 0, minus: m.rate_adv < 0}">
                  {{
                    m.rate_adv >= 0 ? '+' : ''
                  }}{{ m.rate_adv && m.rate_adv !== -10000 ? (Math.round(m.rate_adv * 100) / 100).toFixed(2) + '%' : '-' }}
                </td>
                <td class="rate-max" v-bind:class="{plus: m.rate_max >= 0, minus: m.rate_max < 0}">
                  {{
                    m.rate_max >= 0 ? '+' : ''
                  }}{{ m.rate_max && m.rate_max !== -10000 ? (Math.round(m.rate_max * 100) / 100).toFixed(2) + '%' : '-' }}
                </td>
                <td class="rate-min" v-bind:class="{plus: m.rate_min >= 0, minus: m.rate_min < 0}">
                  {{
                    m.rate_min >= 0 ? '+' : ''
                  }}{{ m.rate_min && m.rate_min !== -10000 ? (Math.round(m.rate_min * 100) / 100).toFixed(2) + '%' : '-' }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="cts_box">
          <div class="button_wrap mt20">
            <router-link :to="{name: 'AtsuatsuLp'}" class="submit arrow back light skeleton large">戻る</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
      fetch_total_ranks: null,
      total_rank: 'ranks_adv',
    }
  },
  mounted() {
    this.fetchTotalRanks()
  },
  methods: {
    fetchTotalRanks() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/total_ranks.json`, {
            params: {
              rank_count: null
            }
          })
          .then(response => {
            this.fetch_total_ranks = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
  }
}
</script>

<style lang="scss">
.box {
  padding: 0 30px 0 30px;

  &.list {
    margin-bottom: 30px;

    .minus {
      color: red;
    }

    th, td {
      word-break: break-all;
    }
  }
}
</style>
